import './ProgressContextRow.css';

/**
 * The row under the My Progress header: who you are looking at on the left
 * (a dropdown when `picker` is given), and the year scope on the right.
 */
const ProgressContextRow = ({ label, picker = null, children }) => (
  <div className="progress-context">
    {picker ? (
      <details className="progress-reader-picker">
        <summary className="progress-context-reader">{label}</summary>
        <div className="progress-reader-picker-panel">{picker}</div>
      </details>
    ) : (
      <span className="progress-context-reader">{label}</span>
    )}
    {children}
  </div>
);

export default ProgressContextRow;
